module.exports = __webpack_public_path__ + "img/halloween-window-25.eafa2802.svg";